import { Label, TooltipHost } from "@fluentui/react";
import { IDictionary, isNullOrEmpty } from "@ioip/core/lib/utilities";
import React from "react";
import { ControlType, JSDataTableColumn } from "../../types";
import { JSRuleError } from "../types/JSRuleError";
import { IFieldValue } from "../types/IFieldValue";
import CComboBox from "../types/CComboBox";

interface IDataTableColumnComponentProps {
    column: JSDataTableColumn;
    row: IDictionary<any>;
}

export const UXDataTableColumn = (props: IDataTableColumnComponentProps): JSX.Element => {

    let text: IFieldValue | JSRuleError;
    if (isNullOrEmpty(props.column.customValue)) {
        if (props.column.datatable.controlType === ControlType.entityDataTable) {
            //const attributeCode = props.column.attribute.code;
            text = { value: props.row[ 'Nombre' ]?.value };
        }
        else {
            const value = props.row[ props.column.fieldId ];
            if (props.column.field instanceof CComboBox) {
                text = { value: props.column.field?.datasource?.getText(value) || '#REF!' };
            }
            else {
                text = value;
            }
        }
    } else {

        const proxy: IDictionary<any> = new Proxy(props.row, {
            get: (target, propName: string) => {

                if (propName === '__target__')
                    return target;

                // Obtener el campo del formulario que se va a evaluar
                const form = props.column.datatable.getForm();
                const field = form.fields.firstOrDefault(x => x.name == propName);
                if (field == null)
                    return null;
                return props.row[ field.id.toString() ];

            },
            set: () => {
                return false;
            }
        });

        // const func = buildDefaultRule<string>(props.column.customValue, props.column.datatable, props.column.datatable.getForm(), proxy);
        text = { value: "Prueba" };
    }

    if (text instanceof JSRuleError)
        return <TooltipHost content={(<Label>{text.message}</Label>)}>
            <span
                style={{
                    color: 'red'
                }}
            >{text.toString()}</span>
        </TooltipHost>

    return <span>{text?.value || ''}</span>

}